import { setDefaultOptions, loadCss } from 'esri-loader';
setDefaultOptions({ version: '4.11' });
loadCss();
